/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartCategoryResponse
 */
export interface PartCategoryResponse {
    /**
     * 
     * @type {number}
     * @memberof PartCategoryResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PartCategoryResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartCategoryResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the PartCategoryResponse interface.
 */
export function instanceOfPartCategoryResponse(value: object): value is PartCategoryResponse {
    return true;
}

export function PartCategoryResponseFromJSON(json: any): PartCategoryResponse {
    return PartCategoryResponseFromJSONTyped(json, false);
}

export function PartCategoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartCategoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function PartCategoryResponseToJSON(json: any): PartCategoryResponse {
    return PartCategoryResponseToJSONTyped(json, false);
}

export function PartCategoryResponseToJSONTyped(value?: PartCategoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

